import React, { useState, useEffect, useRef } from 'react';
import { stockService } from '../services/api';
import './SearchExpert.css';

const SearchExpert = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [result, setResult] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [oldRef, setOldRef] = useState(''); // Mémorise la REF avant modification
    const inputRef = useRef(null);

    useEffect(() => { inputRef.current.focus(); }, []);

    const handleSearch = async (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (value.length > 1) {
            const allProducts = await stockService.getAllProducts();
            const exactMatch = allProducts.find(p => p.code_barre === value || p.ref_produit === value);
            if (exactMatch) {
                setResult(exactMatch);
                setSuggestions([]);
            } else {
                const filtered = allProducts.filter(p =>
                    p.designation.toLowerCase().includes(value.toLowerCase()) ||
                    p.ref_produit.toLowerCase().includes(value.toLowerCase())
                ).slice(0, 5);
                setSuggestions(filtered);
                setResult(null);
            }
        } else {
            setSuggestions([]);
            setResult(null);
        }
    };

    const handleEditClick = () => {
        setOldRef(result.ref_produit); // On stocke la référence actuelle comme "old_ref"
        setIsEditing(true);
    };

    const handleSave = async () => {
        try {
            // On envoie le résultat + la old_ref pour le WHERE du SQL
            const res = await stockService.updateProduct({ ...result, old_ref: oldRef });
            if (res.success) {
                setIsEditing(false);
                alert("Produit mis à jour !");
            } else {
                alert("Erreur: " + res.message);
            }
        } catch (e) { alert("Erreur de connexion"); }
    };

    return (
        <div className="dashboard-container">
            <div className="search-focus-zone">
                <h1>{isEditing ? "Modification de Fiche" : "Recherche Expert"}</h1>
                <div className="search-wrapper">
                    <input
                        ref={inputRef}
                        type="text"
                        className="huge-search-input"
                        placeholder="Scan ou Nom..."
                        value={searchTerm}
                        onChange={handleSearch}
                        disabled={isEditing}
                    />
                    {suggestions.length > 0 && (
                        <ul className="search-suggestions">
                            {suggestions.map(p => (
                                <li key={p.ref_produit} onClick={() => { setResult(p); setSuggestions([]); setSearchTerm('') }}>
                                    <span>{p.designation}</span>
                                    <small>{p.stock_actuel} en stock</small>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>

            {result && (
                <div className="result-card">
                    <div className="result-header">
                        <div className="header-info">
                            {isEditing ? (
                                <div className="edit-group">
                                    <span>Désignation du produit</span>
                                    <input className="edit-input title-edit" value={result.designation} onChange={(e) => setResult({ ...result, designation: e.target.value })} />
                                </div>
                            ) : (
                                <h2>{result.designation}</h2>
                            )}
                        </div>
                        <div className="header-actions">
                            {isEditing && <button className="btn-cancel" onClick={() => setIsEditing(false)}>Annuler</button>}
                            <button className={isEditing ? "btn-save" : "btn-edit"} onClick={isEditing ? handleSave : handleEditClick}>
                                {isEditing ? "💾 Sauver" : "✏️ Modifier"}
                            </button>
                        </div>
                    </div>

                    <div className="result-grid">
                        <div className="res-item">
                            <span>Référence Interne</span>
                            {isEditing ? (
                                <input className="edit-input" value={result.ref_produit} onChange={(e) => setResult({ ...result, ref_produit: e.target.value })} />
                            ) : (
                                <strong>{result.ref_produit}</strong>
                            )}
                        </div>

                        <div className="res-item">
                            <span>Prix d'achat HT</span>
                            {isEditing ? (
                                <input type="number" className="edit-input" value={result.prix_achat_ht} onChange={(e) => setResult({ ...result, prix_achat_ht: e.target.value })} />
                            ) : (
                                <strong>{result.prix_achat_ht} €</strong>
                            )}
                        </div>

                        <div className="res-item">
                            <span>Quantité en stock</span>
                            <div className="qty-editor">
                                <button onClick={() => setResult({ ...result, stock_actuel: parseInt(result.stock_actuel) - 1 })}>-</button>
                                <input type="number" value={result.stock_actuel} onChange={(e) => setResult({ ...result, stock_actuel: e.target.value })} />
                                <button onClick={() => setResult({ ...result, stock_actuel: parseInt(result.stock_actuel) + 1 })}>+</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchExpert;